export default __webpack_public_path__ + "static/media/WorkshopsEventsFiller.ceb6ce1b.jpg";